import { render } from "./AssembliesPage.vue?vue&type=template&id=15c0f964&scoped=true"
import script from "./AssembliesPage.vue?vue&type=script&lang=js"
export * from "./AssembliesPage.vue?vue&type=script&lang=js"

import "./AssembliesPage.vue?vue&type=style&index=0&id=15c0f964&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15c0f964"]])

export default __exports__